export default (props) => (
  <svg
    width="109"
    height="45"
    viewBox="0 0 109 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    role="img"
  >
    <path
      d="M61.3104 37.0918L51.342 8.51256C51.2546 8.26203 51.4408 8 51.7074 8H60.2463C60.506 8 60.7358 8.16779 60.8163 8.41372L66.2246 25.0501C66.4039 25.5994 67.1785 25.6017 67.3623 25.0547L72.9453 8.40913C73.0281 8.16549 73.2556 8 73.513 8H81.76C82.0266 8 82.2151 8.26662 82.1231 8.51716L71.8306 37.0987C71.7455 37.3354 71.5203 37.494 71.2674 37.494H61.8759C61.6207 37.494 61.3932 37.3331 61.3104 37.0918Z"
      fill="#1D1F21"
    />
    <path
      d="M11.9415 37.2343L1.92479 8.51256C1.83745 8.26203 2.02363 8 2.29025 8H10.9831C11.1509 8 11.298 8.10803 11.3508 8.26662L17.0074 25.6615C17.1223 26.0154 17.6234 26.0177 17.7406 25.6638L23.5764 8.26432C23.6293 8.10573 23.7764 8 23.9419 8H32.3428C32.6094 8 32.7979 8.26662 32.7059 8.51716L22.3628 37.2389C22.3077 37.3929 22.1629 37.494 21.9997 37.494H12.307C12.1415 37.494 11.9967 37.3906 11.9415 37.2343Z"
      fill="#1D1F21"
    />
    <path
      d="M47.2484 8.34477L57.2353 36.9791C57.3226 37.2297 57.1364 37.4917 56.8698 37.4917H48.2712C48.0483 37.4917 47.8506 37.3469 47.7816 37.1354L42.2745 20.2003C42.1205 19.7291 41.4539 19.7245 41.2977 20.1957L35.6158 37.14C35.5446 37.3492 35.3492 37.4917 35.1286 37.4917H26.8196C26.5529 37.4917 26.3668 37.2251 26.4564 36.9746L36.7674 8.34017C36.8409 8.13561 37.034 8 37.2523 8H46.7634C46.9818 8 47.1749 8.13791 47.2484 8.34477Z"
      fill="#1D1F21"
    />
    <path
      d="M99.1226 30.3044H78.441C78.0272 30.3044 77.6595 30.5618 77.5147 30.9502L75.3518 36.8182C75.2277 37.1538 75.4759 37.5124 75.8345 37.5101L96.569 37.4986C96.985 37.4986 97.3551 37.2366 97.4976 36.8458L99.6053 30.9939C99.7271 30.6583 99.4789 30.3044 99.1226 30.3044Z"
      fill="#1D1F21"
    />
    <path
      d="M103.136 19.1615H82.546C82.1323 19.1615 81.7623 19.4189 81.6198 19.8073L79.4569 25.6753C79.3328 26.0109 79.581 26.3672 79.9396 26.3672L100.584 26.3557C101 26.3557 101.371 26.0937 101.513 25.7029L103.621 19.8487C103.74 19.5154 103.492 19.1615 103.136 19.1615Z"
      fill="#1D1F21"
    />
    <path
      d="M107.149 8.01839H86.4649C86.1615 8.01839 85.8926 8.20686 85.7869 8.49187L83.5597 14.5323C83.4355 14.8678 83.6838 15.2264 84.0423 15.2264L104.781 15.2172C105.085 15.2172 105.358 15.0264 105.462 14.7391L107.634 8.71023C107.753 8.37005 107.505 8.01839 107.149 8.01839Z"
      fill="#1D1F21"
    />
  </svg>
)
